/* =========================================
   STAFF PAGE ANIMATIONS
   ========================================= */
document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    let mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {

    // Founders Grid Reveal
    if (document.querySelector('.founders-grid')) {
        gsap.timeline({
            scrollTrigger: { trigger: '.founders-grid', start: 'top 85%' }
        }).fromTo('.founders-grid .staff-card',
            { opacity: 0, y: 40, scale: 0.95 },
            { opacity: 1, y: 0, scale: 1, duration: 0.8, stagger: 0.15, ease: 'back.out(1.2)' }
        );
    }

    // Ethos Break Reveal
    if (document.querySelector('.ethos-break')) {
        gsap.timeline({
            scrollTrigger: { trigger: '.ethos-break', start: 'top 85%' }
        }).fromTo('.ethos-break .container > *',
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }
        );
    }

    // Staff Cards Grid Reveal
    if (document.querySelector('.team-grid')) {
        gsap.timeline({
            scrollTrigger: { trigger: '.team-grid', start: 'top 85%' }
        }).fromTo('.team-grid .staff-card',
            { opacity: 0, y: 40, scale: 0.95 },
            { opacity: 1, y: 0, scale: 1, duration: 0.8, stagger: 0.15, ease: 'back.out(1.2)' }
        );
    }
    }); // End matchMedia
});
